const nl = {
  "Generation_Form_{label}MoetGroterZijnDan{amount}": "'{{label}}' getal moet groter zijn dan {{amount}}.",
  "Generation_Form_{label}MoetMinimaal{amount}Zijn":
    "'{{label}}' getal moet minimaal {{amount}} of hoger zijn.",
  "Generation_Form_{label}MoetKleinerZijnDan{amount}": "'{{label}}' getal moet kleiner zijn dan {{amount}}.",
  "Generation_Form_{label}MagMaximaal{amount}Zijn":
    "'{{label}}' getal moet maximaal {{amount}} of lager zijn.",
  "Generation_Form_MinimaalEen{label}IsVerplicht": "Er is minimaal één '{{label}}' verplicht",
  "Generation_Form_{label}MoetEenBedragZijn": "'{{label}}' moet een bedrag zijn.",
  "Generation_Form_{label}MoetEenBsnZijn":
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het burgerservicenummer bestaat uit 9 cijfers.",
  "Generation_Form_{label}MoetGelijkZijnAan{compareValue}":
    "'{{label}}' is ongelijk aan '{{compareValue}}' en daarom niet toegestaan.`",
  "Generation_Form_{label}MoetOngelijkZijnAan{compareValue}":
    "'{{label}}' is gelijk aan '{{this.compareValue}}' en daarom niet toegestaan.",
  "Generation_Form_{label}MoetEenDatumZijn": "'{{label}}' is ongeldig.",
  "Generation_Form_{label}MoetEenDecimaalZijn": "'{{label}}' is ongeldig.",
  "Generation_Form_{label}MoetEenGeldigEmailAdresZijn":
    "U heeft het invulveld '{{label}}' niet juist ingevuld, voorbeeld: naam@domein.nl (vervangen door uw eigen e-mailadres).",
  "Generation_Form_{label}MoetGelijkZijnAan{valueToEqual}":
    "'{{label}}' is niet gelijk aan '{{valueToEqual}}'.",
  "Generation_Form_Alleen{extensions}ZijnGeldig": "Alleen de extensies '{{extensions}}' zijn toegestaan.",
  "Generation_Form_{fileLabel}MoetVanHetType{extensions}Zijn":
    "'{{fileLabel}}' heeft een ongeldige extensie. Alleen de extensies '{{extensions}}' zijn toegestaan.",
  "Generation_Form_{label}MagNietGroterZijnDan{maxSizeInMB}":
    "U heeft in het invulveld '{{label}}' meer dan de maximaal toegestane bestandsgrootte geüpload, bijlagen mogen maximaal {{maxSizeInMB}}MB zijn.",
  "Generation_Form_{fileLabel}MagNietGroterZijnDan{maxSizeInMB}":
    "'{{fileLabel}}' is groter dan de maximaal toegestane bestandsgrootte, bijlagen mogen maximaal {{maxSizeInMB}}MB zijn.",
  "Generation_Form_{label}MagMaximaal{maxFiles}BijlagenZijn":
    "U heeft in het invulveld '{{label}}' meer dan het toegestane aantal bijlagen geüpload, u mag maximaal {{maxFiles}} bijlage(n) uploaden.",
  "Generation_Form_{label}MagNietGroterZijnDan{maxLength}":
    "'{{label}}' mag niet meer dan {{maxLength}} karakters hebben.",
  "Generation_Form_{label}MoetMinimaal{mizSizeInBytes}Zijn":
    "U heeft in het invulveld '{{label}}' minder dan de minimaal toegestane bestandsgrootte geüpload, bijlagen moeten minimaal {{minSizeInBytes}} byte(s) zijn.",
  "Generation_Form_{fileLabel}MoetMinimaal{mizSizeInBytes}Zijn":
    "'{{fileLabel}}' is kleiner dan de minimaal toegestane bestandsgrootte, bijlagen moeten minimaal {{minSizeInBytes}} byte(s) zijn.",
  "Generation_Form_{label}GetalMoetMinimaal{amount}Zijn":
    "'{{label}}' getal moet minimaal {{amount}} of hoger zijn.",
  "Generation_Form_{label}MoetBestaanUit{specificLength}Characters":
    "'{{label}}' moet bestaan uit {{specificLength}} karakters.",
  "Generation_Form_{label}MoetEenGeldigIBANZijn":
    "U heeft het invulveld '{{label}}' niet juist ingevuld, voorbeeld: NL01ABCD0123456789 (vervangen door uw eigen IBAN).",
  "Generation_Form_{label}MoetEenGeheelGetalZijn": "'{{label}}' is ongeldig.",
  "Generation_Form_{label}MagGeenLegeFileBevatten":
    "U heeft in het invulveld '{{label}}' een lege bijlage geüpload, bijlagen mogen niet leeg zijn.",
  "Generation_Form_{fileLabel}MagGeenLegeFileZijn":
    "'{{fileLabel}}' is een lege bijlage, bijlagen mogen niet leeg zijn.",
  "Generation_Form_{label}IsVerplicht": "U heeft het invulveld '{{label}}' niet ingevuld.",
  "Generation_Form_{label}IsNotEqualTo{firstLabel}": "'{{label}}' is niet gelijk aan '{{firstLabel}}'.",
  "Generation_Form_{label}MoetOpOfNa{minimumDate}Zijn": "'{{label}}' moet op of na {{minimumDate}} zijn.",
  "Generation_Form_{label}IsEqualTo{firstLabel}": "'{{label}}' is gelijk aan '{{firstLabel}}'.",
  "Generation_Form_{label}IsGeenGeldigeDatumOfInDeToekomst":
    "'{{label}}' is een ongeldige datum of is een toekomstige datum.",
  "Generation_Form_{label}IsGeenGeldigTelefoonnummer":
    "U heeft het invulveld '{{label}}' niet juist ingevuld, voorbeeld: 040-1234567 (vervangen door uw eigen telefoonnummer).",
  "Generation_Form_{label}IsGeenGeldigePostcode": "U heeft het invulveld '{{label}}' niet juist ingevuld, voorbeeld: 1234 AB (vervangen door uw eigen postcode).",
  "Generation_Form_{label}IsGeenGeldigeWaard": "U heeft het invulveld '{{label}}' niet juist ingevuld.",
  "Generation_Form_{label}MoetKleinerOfGelijkZijnAan{datumTmLabel}":
    "{{label}} mag niet na {{datumTmLabel}} liggen.",
  "Generation_Form_{label}MoetKleinerZijnDan{datumTmLabel}": "{{label}} moet voor {{datumTmLabel}} liggen.",
  "Generation_Form_{label}IsGeenGeldigeWaarde":
    "U heeft in het invulveld '{{label}}' geen geldige waarde ingevoerd."
};

export default nl;
